import { render, staticRenderFns } from "./CbtExamOthers.vue?vue&type=template&id=56930840&scoped=true"
import script from "./CbtExamOthers.vue?vue&type=script&lang=js"
export * from "./CbtExamOthers.vue?vue&type=script&lang=js"
import style0 from "./CbtExamOthers.vue?vue&type=style&index=0&id=56930840&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56930840",
  null
  
)

export default component.exports